import React from "react";
import { Box, Badge, Link, SpaceBetween } from "@amzn/awsui-components-react";

/**
 * A single course card inside a curriculum cell. Shows the title, provider +
 * duration, and status badges (being built / mandatory / ETA). When a URL is
 * present the title links out to the training; otherwise it renders as plain
 * text (e.g. while a course is still being built).
 */
const CourseCard = ({ course, tierCode }) => {
  if (!course) return null;

  const providerLine = [course.provider_name, course.duration_label]
    .filter(Boolean)
    .join(" · ");

  const beingBuilt = course.status === "BEING_BUILT";

  const titleNode =
    course.url && !beingBuilt ? (
      <Link href={course.url} external fontSize="body-m">
        {course.title}
      </Link>
    ) : (
      <Box variant="strong">{course.title}</Box>
    );

  // Tint the card to its tier (matches the prototype's purple/teal/pink cells).
  const tierClass = tierCode ? ` raise-tier-${tierCode.toLowerCase()}` : "";

  return (
    <Box padding="s" className={`raise-course-card${tierClass}`}>
      <SpaceBetween size="xxs">
        {titleNode}
        {providerLine ? (
          <Box color="text-body-secondary" fontSize="body-s">
            {providerLine}
          </Box>
        ) : null}
        <SpaceBetween direction="horizontal" size="xxs">
          {course.is_mandatory ? <Badge color="red">mandatory</Badge> : null}
          {beingBuilt ? <Badge color="grey">being built</Badge> : null}
          {course.eta_date ? (
            <Badge color="blue">{`ETA ${course.eta_date}`}</Badge>
          ) : null}
        </SpaceBetween>
      </SpaceBetween>
    </Box>
  );
};

export default CourseCard;
